import API from "../axiosConfig";

export const getStatistics = async () => {
  try {
    const response = await API.get(`/statistics`);
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};
